import { IsoLocale, Locales } from "@simplyk/common";

export const formatDayOfMonthOrdinal = (day: number, locale: Locales | IsoLocale): string => {
  if (locale.startsWith("fr")) {
    return day === 1 ? "1er" : String(day);
  }
  if (locale.startsWith("de")) {
    return `${day}.`;
  }
  if (locale.startsWith("es")) {
    return String(day);
  }
  const englishOrdinalRules = new Intl.PluralRules("en", { type: "ordinal" });
  const suffixes: Record<string, string> = { one: "st", two: "nd", few: "rd", other: "th" };
  return `${day}${suffixes[englishOrdinalRules.select(day)]}`;
};
